import { render, staticRenderFns } from "./TopSonResultsTableDetail.vue?vue&type=template&id=208d4441&scoped=true"
import script from "./TopSonResultsTableDetail.vue?vue&type=script&lang=js"
export * from "./TopSonResultsTableDetail.vue?vue&type=script&lang=js"
import style0 from "./TopSonResultsTableDetail.vue?vue&type=style&index=0&id=208d4441&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208d4441",
  null
  
)

export default component.exports